import { Button, Stack, TextField, Typography } from '@mui/material'

export default function AutomationSetupActions({ approvalRequired, days, setDays, pending, activate }) {
  const duration = Number(days)
  const validDuration = Number.isInteger(duration) && duration >= 1 && duration <= 365

  return (
    <Stack spacing={1.25}>
      {approvalRequired ? (
        <>
          <TextField
            type="number" size="small" label="Approval duration"
            value={days}
            onChange={(event) => setDays(event.target.value)}
            helperText="You can change or revoke this permission later."
            slotProps={{ htmlInput: { min: 1, max: 365, step: 1 } }}
          />
          <Typography variant="caption" color="text.secondary">
            This approval expires after {validDuration ? `${duration} days` : 'a duration from 1 to 365 days'}.
          </Typography>
        </>
      ) : null}
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          disabled={pending || (approvalRequired && !validDuration)}
          onClick={() => activate(approvalRequired ? duration : 1)}
        >
          {pending
            ? 'Activating…'
            : approvalRequired
              ? 'Approve and activate'
              : 'Activate automation'}
        </Button>
        <Button
          variant="outlined"
          color="error"
          size="small"
          disabled={pending}
        >
          Cancel
        </Button>
      </Stack>
    </Stack>
  )
}
